import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PostGraduatePartExamTemplateItem, PostGraduatePartExamTemplate } from '../models';

export class PostGraduatePartExamTemplateApi extends ApiModule {
  protected endpoint = '/post-graduate-part-exam-template';

  public async pagePostGraduatePartExamTemplates(params: any) {
    return this.api.post<PaginatedResponseData<PostGraduatePartExamTemplateItem>, any>(`${this.endpoint}/page`, {
      ...params
    });
  }

  public loadPostGraduatePartExamTemplateDetails(id: number) {
    return this.api.get<PostGraduatePartExamTemplate>(`${this.endpoint}?id=${id}`);
  }

  public savePostGraduatePartExamTemplate(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePostGraduatePartExamTemplate(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
